import Feedbacks from './Feedbacks'
import { List, RequestAdminFeedbackModal } from './children'

export default Feedbacks
export { List, RequestAdminFeedbackModal }
